var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 232,
    viewBox: "0 0 231 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3346 194.666C32.2013 194.666 27.8084 192.84 24.156 189.188C20.5035 185.535 18.6742 181.139 18.668 176V63.9997C18.668 58.8663 20.4973 54.4735 24.156 50.821C27.8146 47.1686 32.2075 45.3392 37.3346 45.333H85.6346C88.1235 45.333 90.4973 45.7997 92.756 46.733C95.0146 47.6663 96.9964 48.9886 98.7013 50.6997L112.001 63.9997H186.668C191.801 63.9997 196.197 65.829 199.856 69.4877C203.515 73.1463 205.341 77.5392 205.335 82.6663V176C205.335 181.133 203.508 185.529 199.856 189.188C196.204 192.846 191.808 194.673 186.668 194.666H37.3346Z",
    fill: "#FF8CD1",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.639 43.7584L104.641 43.7603L117.941 57.0603L118.38 57.4997H119.001H193.668C198.4 57.4997 202.415 59.1685 205.795 62.5483C209.175 65.9282 210.84 69.94 210.835 74.6645V74.6663V168C210.835 172.732 209.168 176.748 205.794 180.128C202.422 183.506 198.408 185.172 193.67 185.166H193.668H44.3346C39.6019 185.166 35.5897 183.5 32.2166 180.127C28.8437 176.754 27.1739 172.738 27.168 167.999V55.9997C27.168 51.2678 28.8367 47.2559 32.2157 43.8826C35.596 40.508 39.6093 38.8389 44.3356 38.833H92.6346C94.9307 38.833 97.1095 39.2624 99.1831 40.1193C101.261 40.9778 103.075 42.1895 104.639 43.7584Z",
    stroke: "#FF8CD1",
    strokeOpacity: 0.5,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.ac177f19378cc862ee8a32a8dbaf55aa.svg";
export { ForwardRef as ReactComponent };